import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './InfoToast.css';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const InfoToast = (props) => {
    return (
        <Snackbar className='zoom-info-msg' open={true} autoHideDuration={3000} anchorOrigin={{vertical:'bottom',horizontal:'center'}} >
            <Alert severity="info">{props.msg}</Alert>
        </Snackbar>

    );
}

export default InfoToast;